import React, { useContext } from "react";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import OPTIONS_CONTENT from "../../../content/options.content";
import { PERIODS, TARIFF_INFORMATION } from "../../../content/index.content";
import { getTrueClasses } from "../../../../../../helpers";
import "./index.scss";

const SubTitle = () => {
  const {
    data: { options, optionsState, currentPeriod, availableTariffs },
    translate: { t },
  } = useContext(SimpleContext);

  const { subTitle } =
    TARIFF_INFORMATION[availableTariffs[currentPeriod || PERIODS[1]]];

  const { PL, R } = OPTIONS_CONTENT[currentPeriod || PERIODS[1]];
  const isPL = options.includes("PL") && optionsState.PL;
  const isR = options.includes("R") && optionsState.R;

  return (
    <div
      className={getTrueClasses(
        "GP-C-SB-T-ST",
        !isPL && !isR && !subTitle && "GP-C-SB-T-ST_empty"
      )}
    >
      {subTitle && (
        <p className="GP-C-SB-T-ST__text GP-C-SB-T-ST__text_AI">
          {t(subTitle.text)}
        </p>
      )}
      {isPL && (
        <p className="GP-C-SB-T-ST__text GP-C-SB-T-ST__text_PL">
          {t(PL.subTitle)}
        </p>
      )}
      {isR && (
        <p className="GP-C-SB-T-ST__text GP-C-SB-T-ST__text_R">
          {t(R.subTitle)}
        </p>
      )}
    </div>
  );
};

export default SubTitle;
